import { postListFetcher } from '@/shared/api/list';
import { DeleteButton } from '@/shared/ui/list/DeleteButton';
import {
  FormModalButton,
  type EntityField,
  type EntityValues,
} from '@/shared/ui/list/EntityFormModal';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { deleteTag, saveTag } from './api';

const LIST_KEY = 'publications-tags';

interface Tag extends ListRow {
  id: number;
  name?: string;
  slug?: string;
  sort?: number | string;
}

const EDIT_FIELDS: EntityField[] = [
  { name: 'name', label: 'Имя', placeholder: 'Заголовок...' },
  { name: 'slug', label: 'ЧПУ', placeholder: 'ЧПУ...' },
];

/** Sort id can only be set on creation (legacy edit form has no such field). */
const CREATE_FIELDS: EntityField[] = [
  ...EDIT_FIELDS,
  { name: 'sortId', label: 'Сортировка', type: 'number', placeholder: 'Sort id...' },
];

const save = (id?: number) => (v: EntityValues) =>
  saveTag(id, { name: String(v.name), slug: String(v.slug), sortId: String(v.sortId ?? '') });

const config: ListPageConfig<Tag> = {
  queryKey: LIST_KEY,
  title: 'Теги',
  boxTitle: 'Теги',
  errorText: 'Ошибка загрузки тегов',
  fetchList: postListFetcher('/publication/tag/index/'),
  rows: ['items'],
  headerActions: (
    <FormModalButton
      buttonLabel="Создать"
      buttonClassName="btn btn-info pull-right"
      title="Создать тег"
      fields={CREATE_FIELDS}
      initial={{ name: '', slug: '', sortId: '' }}
      save={save()}
      listKey={LIST_KEY}
    />
  ),
  columns: [
    { header: 'id', render: (tag) => tag.id },
    { header: 'ЧПУ', render: (tag) => tag.slug || 'No slug' },
    { header: 'Сортировка', render: (tag) => tag.sort || 'No sort' },
    { header: 'Имя', render: (tag) => tag.name || 'No name' },
    {
      header: 'Edit',
      render: (tag) => (
        <FormModalButton
          buttonLabel="Edit"
          title="Редактировать тег"
          fields={EDIT_FIELDS}
          initial={{ name: tag.name ?? '', slug: tag.slug ?? '' }}
          save={save(tag.id)}
          listKey={LIST_KEY}
        />
      ),
    },
    {
      header: 'Delete',
      render: (tag) => <DeleteButton listKey={LIST_KEY} remove={() => deleteTag(tag.id)} />,
    },
  ],
};

export const TagsPage = () => <GenericListPage config={config} />;
